import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '@one-thd/sui-atomic-components';
import { useConfigService } from '@thd-nucleus/experience-context';
import { List } from '../../common/List/List';
import { unverifiedBenefitsList } from '../../../constants/constants';
import { IdmeVerification } from '../../IdmeVerification';

function UnverifiedDIY(props) {
  const { verifyOnClick, customerAccountId, userId, channelId } = props;
  const isIdmeEnabled = !!useConfigService('ENABLE_MILITARY_VERIFICATION_IDME');
  return (
    <div className="sui-grid sui-gap-y-8">
      {!isIdmeEnabled && (
        <p>
          Please choose the appropriate option based on your status to get
          started:{' '}
        </p>
      )}
      <div className="sui-grid sui-grid-cols-1 sm:sui-grid-cols-4 sui-justify-items-left sui-gap-4">
        {isIdmeEnabled ? (
          <IdmeVerification
            customerAccountId={customerAccountId}
            userId={userId}
            channelId={channelId}
          />
        ) : (
          <>
            <Button variant="secondary" onClick={() => verifyOnClick(false)}>
              Military Member or Gold Star
            </Button>
            <Button variant="secondary" onClick={() => verifyOnClick(true)}>
              Spouse
            </Button>
          </>
        )}
      </div>
      <List list={unverifiedBenefitsList} />
    </div>
  );
}

UnverifiedDIY.propTypes = {
  verifyOnClick: PropTypes.func,
  customerAccountId: PropTypes.string,
  userId: PropTypes.string,
};
UnverifiedDIY.defaultProps = {
  verifyOnClick: () => {},
};

export default UnverifiedDIY;
